/**
 * Renders the current assets summary for a group of asset tags.
 * ex: 3/8 Devices
 */
import pluralize from '@kentik/ui-shared/util/pluralize';
import AssetTagInventoryCollection from 'app/stores/assetTags/AssetTagInventoryCollection';
import AssetTagInventoryModel from 'app/stores/assetTags/AssetTagInventoryModel';

interface Props {
  group: AssetTagInventoryModel[];
  collection: AssetTagInventoryCollection;
}

function currentAssetsRenderer(props: Props): string {
  const { group, collection } = props;
  const { totalAssetCount, assetLabel } = collection || {};

  return `${group?.length || 0} / ${totalAssetCount} ${pluralize(assetLabel, totalAssetCount)}`;
}

export default currentAssetsRenderer;
